import React, { Suspense } from 'react';
import lazyLoader from '@utils/lazyLoader';

const InputPINLazy = lazyLoader(
  () => import('./InputPIN' /* webpackChunkName: "input-pin" */),
);

const InputPin = () => {
  return (
    <Suspense fallback={null}>
      <InputPINLazy />
    </Suspense>
  );
};

export default InputPin;
